import axios from 'axios';
import { stagedApis } from 'src/constants';

/*
HTTP api gateway implementation, handles all user and billing functions
*/

export default axios.create({
  baseURL: stagedApis.edgeUsersApi
});